// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sdGlobalSearchBaseURL } from '../../constants/index';
import axios from 'axios';


const initialState = {
	loading: false,
	error: '',
	events: [],
	filters: [],
	total: 0
};

export const getEventsWithFilters = createAsyncThunk('eventSlice/getEventsWithFilters', async (query) => {
    try {

        return await axios.get(sdGlobalSearchBaseURL + "?q=*&locale=en-us&fl=sourceType,primaryImage,documentType,id,title,content,documentTypeDate&rows=9&fq=documentType:Press%20Release&groupBy=documentType,yearMonth,cqTagsName_s&sort=docModifiedDate", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});
export const getEvents = createAsyncThunk('eventSlice/getEvents', async (query) => {
    try {
        return await axios.get(sdGlobalSearchBaseURL + "?q=*&locale=en-us&fl=sourceType,primaryImage,documentType,id,title,content,documentTypeDate&rows=9&fq=documentType:Press%20Release&groupBy=documentType,yearMonth,cqTagsName_s&sort=docModifiedDate", {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});

const eventSlice = createSlice({
    name: 'eventSlice',
    initialState,
    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEventsWithFilters.pending, (state) => {
                state.loading = true;
            })
            .addCase(getEventsWithFilters.fulfilled, (state, action) => {
                state.loading = false;
                state.events=action.payload.docs
				state.total=action.payload.total
            })
            .addCase(getEventsWithFilters.rejected, (state, action) => {
                state.loading = false;
                state.search.error = action.error.message;
            })
            .addCase(getEvents.pending, (state) => {
                state.loading = true;
            })
            .addCase(getEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.filters = action.payload.facet_fields;
				state.events=action.payload.docs
				state.total=action.payload.total
            })
            .addCase(getEvents.rejected, (state, action) => {
                state.loading = false;
                // state.productCarousel.error = action.error.message;
            });
    },
});

export const { resetProductList,resetSearchPage } = eventSlice.actions;

export default eventSlice.reducer;
